export default "__VITE_ASSET__BD37RrqL__"